import React from "react";
import { shape, number } from "prop-types";
import { useTranslation } from "@lib/i18n";

import ErrorPage from "@components/shared/ErrorPage";

export function withError(Component) {
  const WithErrorComponent = props => {
    const { errorStatusCode } = props.pageProps;
    const { t } = useTranslation();

    if (typeof errorStatusCode === "number") {
      switch (errorStatusCode) {
        case 404:
          return <ErrorPage title={t("errors.404")} />;
        default:
          return <ErrorPage />;
      }
    }

    return <Component {...props} />;
  };

  WithErrorComponent.propTypes = {
    pageProps: shape({
      errorStatusCode: number,
    }),
  };

  WithErrorComponent.getInitialProps = Component.getInitialProps;

  return WithErrorComponent;
}
